import React, { useRef } from 'react';
import { Moment } from 'moment';
import { Box, Stack, Tooltip } from '@mui/material';
import MonitorOutlinedIcon from '@mui/icons-material/MonitorOutlined';
import { BiActivityIntervalItem } from '../../../types/activity';
import {
  getDimensionPositionTimelineLocalDates,
  ItemWithLocalDates,
} from '../../../utils/worklog';

type Props = {
  items: BiActivityIntervalItemWithLocal[];
  dimensions: { width: number; height: number };
  selectedFilteredDate: Moment;
};

type BiActivityIntervalItemWithLocal = BiActivityIntervalItem &
  ItemWithLocalDates;

const ActivityStack = ({ items = [], selectedFilteredDate }: Props) => {
  const stackRef = useRef<HTMLDivElement | null>(null);

  return (
    <Box display='flex' alignItems='center' flex={1}>
      <Box
        display='flex'
        alignItems='center'
        style={{
          width: 30,
          marginLeft: -30,
        }}
      >
        <MonitorOutlinedIcon style={{ fontSize: 18, opacity: 0.5 }} />
      </Box>
      <Stack
        ref={stackRef}
        direction='row'
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
        }}
      >
        {items.map((item, index, arr) => {
          let { startPos, endPos, startDateLocal, endDateLocal } =
            getDimensionPositionTimelineLocalDates({
              element: stackRef.current,
              startDateLocal: item.start_local,
              endDateLocal: item.end_local,
            });

          let pct = parseFloat((item.activity_percentage * 100).toFixed(2));

          const tooltipTitle = (
            <>
              <span className='tooltip-duration'>{pct}%</span>
              <br />
              <span className='tooltip-task-name'>{item.focus}</span>
              <br />
              <span className='tooltip-start-end'>
                {startDateLocal.format('hh:mm A')} -{' '}
                {endDateLocal ? endDateLocal.format('hh:mm A') : 'ongoing'}
              </span>
            </>
          );

          let bgColor = '';
          if (pct >= 70) {
            bgColor = '#51b7ad';
          } else if (pct >= 11 && pct < 70) {
            bgColor = '#e7e07f';
          } else {
            bgColor = '#c01d0c';
          }

          return (
            <Box
              key={index}
              style={{
                top: 0,
                left: startPos,
                width: endPos,
                height: '100%',
                position: 'absolute',
                background: bgColor,
              }}
            >
              <Tooltip title={tooltipTitle}>
                <Box
                  style={{
                    height: '100%',
                  }}
                />
              </Tooltip>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
};

export default ActivityStack;
